let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3g9JX")).then(() => parcelRequire('he8BE'));